import { FC } from 'react'

import { usePagesDirectoryStableQueryParams } from '../../../../../../lib/adapters/next-routing-service/useUpdateQueryParam'
import { trackEvent } from '../../../../../../lib/analytics'
import { useCollectionPersistentProductHref } from '../../../../../../lib/routing'

import { StyleLink } from './styles'

type Props = {
  title: string
  handle: string
}

export const StyleLinkItem: FC<Props> = ({ title, handle }) => {
  const {
    query: { color, size, fit, plain },
  } = usePagesDirectoryStableQueryParams()

  const href = useCollectionPersistentProductHref(handle, {
    color,
    size,
    fit,
    plain,
  })

  return (
    <StyleLink
      key={handle}
      href={href}
      scroll={false}
      replace
      {...trackEvent({
        category: 'product',
        action: 'click',
        label: 'style links',
        value: handle,
      })}
    >
      {title}
    </StyleLink>
  )
}
